import dayjs from "dayjs";

import {
  PassengerClassificationType,
  PassengerType,
  SEAT_DESCRIPTION,
  SEAT_STATUS,
  SEAT_TYPE,
  SeatKeyType,
  SeatStatusType,
  SeatType,
} from "src/Modules/Flights/constants/JourneyDetails";

const mapSeatToNumber = (seat: SeatType) => {
  return {
    ...seat,
    seatType: SEAT_TYPE[seat.seatSubType as SeatKeyType],
    availablityType: SEAT_STATUS[seat.availabilityType as SeatStatusType],
    description: SEAT_DESCRIPTION[seat.description],
    seatWayType: seat.seatWayType,
  };
};

const mapSSRItems = (pax: PassengerType) => {
  const allSeats: any[] = [];
  const allMeals: any[] = [];
  const allBaggages: any[] = [];

  pax.segments.forEach((segment) => {
    const baggages = Object.entries(segment?.ssr?.baggages ?? {}).flatMap(([key, value]) => value);
    allBaggages.push(...baggages);

    segment.flights.forEach((flight) => {
      const seats = Object.entries(flight?.ssr?.seats ?? {})
        .flatMap(([key, value]) => value)
        .map((seat) => mapSeatToNumber(seat));

      const meals = Object.entries(flight?.ssr?.meals ?? {}).flatMap(([key, value]) => value);

      allSeats.push(...seats);
      allMeals.push(...meals);
    });
  });

  return {
    seat: allSeats.length > 0 ? allSeats : null,
    meal: allMeals.length > 0 ? allMeals : null,
    baggage: allBaggages.length > 0 ? allBaggages : null,
  };
};

function transformIntoFlightsOrder(journeyId: string, input: PassengerType[], value: number, returnUrl: string) {
  const soleAdultIndex = input.filter((pax) => pax.type === "Adult").length === 1
    ? input.findIndex((pax) => pax.type === "Adult")
    : -1;
  return {
    journeyId,
    value,
    externalTransactionId: `ext-client_${journeyId}-${crypto.randomUUID()}`,
    returnUrl,
    passengers: input.map((pax, index) => ({
      addressLine2: null,
      city: {
        countryCode: null,
        cityCode: "CAI",
        cityName: "Cairo",
      },
      country: {
        countryCode: pax.basicData.nationality,
      },
      dateOfBirth: dayjs(pax.basicData.dob).locale("en").format("YYYY-MM-DDTHH:mm:ss[Z]") || "",
      email: pax.basicData.email,
      ffAirline: null,
      ffNumber: null,
      firstname: pax.basicData.firstName || "",
      gender: pax.basicData.gender,
      idCardNo: null,
      idDetails: [
        {
          paxId: index + 1,
          idType: mapPassengerType(pax.type),
          idNumber: pax.basicData.passportNumber,
          issuedCountryCode: pax.basicData.issueCountry,
          issueDate: dayjs(pax.basicData.issueDate).locale("en").format("YYYY-MM-DDTHH:mm:ss[Z]"),
          expiryDate: dayjs(pax.basicData.expiryDate).locale("en").format("YYYY-MM-DDTHH:mm:ss[Z]"),
        },
      ], //IDK WHAT THIS IS OR MEANS, additional documents are required ?? when ?
      isLeadPax: soleAdultIndex >= 0 ? index === soleAdultIndex : !!pax.basicData.isLeadPax,
      lastname: pax.basicData.lastName,
      mobile1: pax.basicData.phoneNumber,
      mobile1CountryCode: "+20",
      nationality: {
        countryCode: pax.basicData.nationality,
      },
      passengerIdExpiry: dayjs(pax.basicData.expiryDate).locale("en").format("YYYY-MM-DDTHH:mm:ss[Z]"),
      passengerIdIssueCountryCode: pax.basicData.issueCountry,
      passengerIdIssueDate: dayjs(pax.basicData.issueDate).locale("en").format("YYYY-MM-DDTHH:mm:ss[Z]"),
      passengerIdNo: pax.basicData.passportNumber,
      passengerIdType: 1,
      passportExpiry: dayjs(pax.basicData.expiryDate).locale("en").format("YYYY-MM-DDTHH:mm:ss[Z]"),
      passportIssueDate: dayjs(pax.basicData.issueDate).locale("en").format("YYYY-MM-DDTHH:mm:ss[Z]"),
      passportNo: pax.basicData.passportNumber,
      paxId: index + 1,
      title: pax.basicData.title,
      type: pax.type,
      addressLine1: pax.basicData.addressLine1,
      ...mapSSRItems(pax), //this maps all the SSR items to the passeneger to three arrays
    })),
  };
}


function mapPassengerType(type: PassengerClassificationType) {
  switch (type) {
    case "Adult":
      return 1;
    case "Child":
      return 2;
    case "Infant":
      return 3;
  }
}


export { transformIntoFlightsOrder };
